import React, { useState } from 'react';
import { verifyEmail } from '../../../utils/auth.controller';
import styles from './Login.module.css'; 
import CreateForm from '../../Design/Forms/CreateForm'; // Import CreateForm component
import { FormFields } from '../../Design/Forms/FormJson'; // Import FormFields
import BackgroundImage from '../../../assets/Background.png';


function VerifyEmail() {
  const [formData, setFormData] = useState({
    code: ''
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Handle change in the verification code input field
  // const handleCodeChange = (event) => {
  //   const enteredCode = event.target.value;
  //   setFormData({ ...formData, code: enteredCode });

    // Clear previous messages
  //   setErrorMessage('');
  //   setSuccessMessage('');
  // };

  // Verify the code when the user clicks the 'Verify Code' button
  const handleVerifyClick = async (e) => {
    e.preventDefault(); // Prevent form from submitting by default
    const { code } = formData;

    // Input validation: Ensure the code is exactly 6 digits
    if (!/^\d{6}$/.test(code)) {
      setErrorMessage('Please enter a valid 6-digit verification code.');
      return;
    }

    try {
      // Call the verifyUserEmail function from auth.controller.js
      await verifyEmail(code);

      // If the verification is successful, display success message
      setSuccessMessage('Email successfully verified!');
      setTimeout(() => {
        window.location.href = '/login'; // Redirect to login page
      }, 1000);
    } catch (error) {
      // Error handling: Display the error message
      console.error('Error occurred:', error.message); // Log the full error for debugging
      setErrorMessage(error.message || 'An error occurred. Please try again later.');
    }
  };

  return (
    <div className={styles.loginPage} style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className={styles.loginImage}></div> {/* You can add a background image if needed */}

      {/* Right Side Form */}
      <div className={styles.loginFormContainer}>
        <div className={styles.loginForm}>
          <h2>Verify Your Email</h2>
          
          {/* Display success or error message */}
          {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
          {successMessage && <p className={styles.successMessage}>{successMessage}</p>}

          {/* Use CreateForm to render verifyEmailFields */}
          <CreateForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleVerifyClick}
            text="Verify Code"
            fields={FormFields.verifyEmailFields} // Pass verifyEmailFields from FormFields
          />
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
